import React from "react";
import { PanelAddSubCategory } from "../../../UI/SubCategories/Add/PanelAddSubCategory";

const AddSubCategory = () => {
  return (
    <div>
      <PanelAddSubCategory />
    </div>
  );
};

export default AddSubCategory;
